module.exports = __webpack_public_path__ + "img/pauli-y.904958e6.svg";